import ARReport from './ARReport'
import TimeEntriesReport from './TimeEntriesReport'
import BillingRealizationReport from './BillingRealizationReport'
import CalendarReport from './CalendarReport'
import APReport, { APDetailReport } from './APReport'
import TrialBalanceReport from './TrialBalanceReport'
import PLReport, { PLComparisonReport } from './PLReport'
import GLBudgetReport from './GLBudgetReport'
import BalanceSheetReport from './BalanceSheetReport'
import GeneralLedgerReport from './GeneralLedgerReport'
import BillJournalReport from './BillJournalReport'
import FeeAllocationReport from './FeeAllocationReport'
import RevenueCommissionsReport from './RevenueCommissionsReport'
import PaymentsByCaseReport from './PaymentsByCaseReport'
import StatusReport from './StatusReport'
import MatterMetricsReport from './MatterMetricsReport'
import ReconciliationHistoryReport from './ReconciliationHistoryReport'
import TimekeeperAnalysisReport from './TimekeeperAnalysisReport'
import MonthlyProductivityReport from './MonthlyProductivityReport'
import FeeReceiptsReport from './FeeReceiptsReport'
import {
  cbPaymentsPaymentsReport,
  cbPaymentsPayoutsReport,
  cbPaymentsReconciliationReport,
  exagoReport,
} from './LegacyEmbedReport'

/**
 * Registry of specialized report renderers, keyed by CB's `actionKey` column
 * on the Report row. When `<ReportView>` loads a report definition, it checks
 * this registry — if there's a match, it renders the specialized component.
 * Otherwise it falls back to the generic dynamic engine.
 *
 * To add a new specialized report:
 *   1. Build the React component under src/pages/reports/.
 *   2. Add cb-api proxy routes for its CB controller endpoints.
 *   3. Register the component below under its actionKey.
 */
export const REPORT_RENDERERS = {
  cbARReportView: ARReport,
  cbTimeEntriesReportView: TimeEntriesReport,
  cbBillingRealizationReportHomeView: BillingRealizationReport,
  cbCalendarReportHomeView: CalendarReport,
  cbAccountsPayableReport: APReport,
  cbAPDetailReportView: APDetailReport,
  cbAccountingTrialBalanceReport: TrialBalanceReport,
  cbAccountingPAndLReport: PLReport,
  cbAccountingPAndLComparisonReport: PLComparisonReport,
  cbAccountingGLActualVsBudgetReport: GLBudgetReport,
  cbAccountingBalanceSheet: BalanceSheetReport,
  cbAccountingGeneralLedgerReport: GeneralLedgerReport,
  // ----- Tier 3 operational -----
  cbBillJournalReportSummaryHomeView: BillJournalReport,
  cbFeeAllocationAttorneyReportView: FeeAllocationReport,
  cbRevenueAndCommissionsView: RevenueCommissionsReport,
  cbPaymentsByCaseView: PaymentsByCaseReport,
  cbDailyReportView: StatusReport,
  // ----- Tier 3 finishers -----
  // CB uses both keys for matter metrics depending on tenant config — alias both.
  cbMatterMetricReportHomeView: MatterMetricsReport,
  cbMatterMetricReport: MatterMetricsReport,
  cbAccountingReconciliationHistory: ReconciliationHistoryReport,
  // ----- Timekeeping / fee analysis (catalog audit additions) -----
  cbTimekeeperAnalysisView: TimekeeperAnalysisReport,
  cbMonthlyProductivityView: MonthlyProductivityReport,
  cbFeeReceiptView: FeeReceiptsReport,
  // CB Payments + Exago are external/embedded dashboards; we hand off to
  // the legacy view rather than reimplement their internal UIs in React.
  cbCBPaymentsPaymentsView: cbPaymentsPaymentsReport,
  cbCBPaymentsPayoutsView: cbPaymentsPayoutsReport,
  cbPaymentsReconciliationHomeView: cbPaymentsReconciliationReport,
  cbExagoReportsHomeView: exagoReport,
}

export const getRendererForActionKey = (actionKey) =>
  actionKey ? REPORT_RENDERERS[actionKey] || null : null
